module.exports = __webpack_public_path__ + "stylesheets/title-block_205c2fe1f0852b7e9533f1514f10c093.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/title-block.less
// module id = 5W2z
// module chunks = 154